import { useState, useEffect } from 'react'
import { useAppContext } from '../../Context'
import styles from './TenderPortalFloat.module.css'

function TenderPortalFloat() {
  const context = useAppContext()
  const [cookieBarVisible, setCookieBarVisible] = useState(!document.cookie.includes('CookieConsent=true'))

  useEffect(() => {
    if (!cookieBarVisible) return

    const observer = new MutationObserver(() => {
      if (document.cookie.includes('CookieConsent=true')) {
        setCookieBarVisible(false)
        observer.disconnect()
      }
    })

    observer.observe(document.body, { childList: true, subtree: true })
    return () => observer.disconnect()
  }, [cookieBarVisible])

  if (!context.loaded || context.user) return null

  const className = cookieBarVisible ? `${styles.float} ${styles.aboveCookieBar}` : styles.float

  return (
    <a
      href="https://in-tendhost.co.uk/epl/aspx/home"
      target="_blank"
      rel="noopener noreferrer"
      className={className}
      aria-label="Open EP Tender Portal in new tab"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
        <polyline points="15 3 21 3 21 9" />
        <line x1="10" y1="14" x2="21" y2="3" />
      </svg>
      EP Tender Portal
    </a>
  )
}

export { TenderPortalFloat }
